const alertBell = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M10.29 13.71a2.29 2.29 0 1 1-4.58 0zM15 11a1 1 0 0 1 0 2H1a1 1 0 0 1 0-2h.5A4.35 4.35 0 0 0 3 8V5a5 5 0 1 1 10 0v3a4.35 4.35 0 0 0 1.5 3z"/></svg>',
};

export { alertBell as default };
